import { toZonedTime, fromZonedTime, format } from 'date-fns-tz';
import { isAfter, startOfDay } from 'date-fns';

// Asia/Calcutta timezone (also known as Asia/Kolkata)
const TIMEZONE = 'Asia/Calcutta';

/**
 * Get current date and time in Asia/Calcutta timezone
 */
export const getCurrentDate = () => {
  return toZonedTime(new Date(), TIMEZONE);
};

/**
 * Convert a date string or Date object to Asia/Calcutta timezone
 */
export const toIndiaTime = (date) => {
  if (!date) return null;
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return toZonedTime(dateObj, TIMEZONE);
};

/**
 * Convert a date from Asia/Calcutta timezone to UTC for storage
 */
export const fromIndiaTime = (date) => {
  if (!date) return null;
  return fromZonedTime(date, TIMEZONE);
};

/**
 * Format date in Indian locale with Asia/Calcutta timezone
 */
export const formatIndianDate = (date, formatStr = 'PPP') => {
  if (!date) return '';
  const zonedDate = toIndiaTime(date);
  return format(zonedDate, formatStr, { timeZone: TIMEZONE });
};

/**
 * Format date and time in Indian locale
 */
export const formatIndianDateTime = (date) => {
  if (!date) return '';
  const zonedDate = toIndiaTime(date);
  return format(zonedDate, 'PPP p', { timeZone: TIMEZONE });
};

/**
 * Format time in Indian locale
 */
export const formatIndianTime = (date) => {
  if (!date) return '';
  const zonedDate = toIndiaTime(date);
  return format(zonedDate, 'p', { timeZone: TIMEZONE });
};

/**
 * Check if a date is in the future (compared to current India time)
 */
export const isFutureDate = (date) => {
  if (!date) return false;
  const dateToCheck = typeof date === 'string' ? new Date(date) : date;
  const currentDate = getCurrentDate();
  const startOfToday = startOfDay(currentDate);
  const startOfDateToCheck = startOfDay(toIndiaTime(dateToCheck));
  return isAfter(startOfDateToCheck, startOfToday) || startOfDateToCheck?.getTime() === startOfToday?.getTime();
};

/**
 * Get start of today in Asia/Calcutta timezone
 */
export const getStartOfToday = () => {
  return startOfDay(getCurrentDate());
};

/**
 * Format date for display in Indian format (DD/MM/YYYY)
 */
export const formatIndianShortDate = (date) => {
  if (!date) return '';
  const zonedDate = toIndiaTime(date);
  return format(zonedDate, 'dd/MM/yyyy', { timeZone: TIMEZONE });
};

/**
 * Format date for display with weekday
 */
export const formatIndianLongDate = (date) => {
  if (!date) return '';
  const zonedDate = toIndiaTime(date);
  return format(zonedDate, 'EEEE, MMMM d, yyyy', { timeZone: TIMEZONE });
};

export { TIMEZONE };